import React, { Fragment } from 'react';
import { isMobile } from 'react-device-detect';
import { isNil } from 'lodash';

/**
 * @desc Check if device is `mobile` and platform is `any-app`.
 * @example
 * import { isApp } from 'core/modules/device-detect';
 */
export const isApp = () => {
	return isMobile && ! isNil( window.device );
};

/**
 * @desc Render children if device is `mobile` and platform is `any-app`.
 * @example
 * import { ForApp } from 'core/modules/device-detect';
 */
export const ForApp = ( props ) => {
	if( isApp() ) {
		return (
			<Fragment>
				{ props.children }
			</Fragment>
		);
	} else {
		return null;
	}
};
